import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnInit, HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Category } from 'src/app/models/category';
import { News } from 'src/app/models/news';
import { AnalitycsService } from 'src/app/services/analitycs.service';
import { CategoryService } from 'src/app/services/category.service';
import { NewsService } from 'src/app/services/news.service';
import { VideoService } from 'src/app/services/video.service';

export interface DataSugerencias {
  id: string;
  categoria: string;
  year: string;
  title: string;
  image: string;
  autor: string;
}

export interface DataCategorias {
  nombre: string;
  image: string;
}

let ELEMENT_DATA_NEW: DataSugerencias[] = [
];

let ELEMENT_DATA_NEW_CATEGORIAS: DataCategorias[] = [
];

@Component({
  selector: 'app-noticias-new',
  templateUrl: './noticias-new.component.html',
  styleUrls: ['./noticias-new.component.scss']
})

export class NoticiasNewComponent implements OnInit {

  @HostListener('window:beforeunload', ['$event'])
  unloadAnalytics($event: any) {
    this.analytics.logEvents("refresh: noticias");
  }

  contador = 10;
  breakpoint: number;
  bigbreakpoint: number;
  videos = [];
  quantityNews : number = 0;
  selector : string = '.sugerencias';
  disabledScroll : boolean = false;

  izquierda() {
    this.contador--;
    if (this.contador == 0) {
      this.contador += 7;
    }
  }
  derecha() {
    this.contador++;
  }
  contasum(num) {
    if ((this.contador % this.news.length + num) > 2)
      return (this.contador % this.news.length + num - 3);
    else
      return (this.contador % this.news.length + num);
  }

  displayedColumns = ['id']
  displayedColumnsCategorias = ['nombre']

  datasourcenew = ELEMENT_DATA_NEW;
  datosArriba = [];
  datosAbajo = [];
  datasugerecias: DataSugerencias;

  datasourcenewcate = ELEMENT_DATA_NEW_CATEGORIAS;
  datasugereciascate: DataCategorias;

  subcribe = new Subscription;

  categoriaActual = "LOCAL";

  noticiaActual: News;
  empotrado: string;
  dataSourceElements;
  news: News[] = [];
  categorys: Category[] = [];
  subscriber: Subscription = new Subscription;
  currentVideo: any;
  newsObserver : BehaviorSubject<News[]> = new BehaviorSubject([]);

  category: string;

  constructor(
    public sanitizer: DomSanitizer,
    public router: Router,
    private newsServ: NewsService,
    private categoryServ: CategoryService,
    private readVideo: VideoService,
    private sanatizer: DomSanitizer,
    private route: ActivatedRoute,
    private analytics: AnalitycsService
  ) {
    this.empotrado = null;
    this.llenarDataSourceCategorias();

    this.newsServ.getVisible().then(news => {
      this.news = news;
      this.newsObserver.next(news);
      this.noticiaActual = this.news[0];
      this.llenarDataSourceNew();
    })

    this.categoryServ.getVisible().then(categorys => {
      this.categorys = categorys.sort(this.sortByName);
      this.category = this.route.snapshot.paramMap.get('id');
      if (this.category) {
        this.cambiarCategoria(this.category);
      }
    })

    this.readVideo.readlastVideo().then(video => {
      this.currentVideo = video[0];
    })
  }

  ngOnDestroy(): void {
    this.subscriber.unsubscribe();
  }

  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 900) ? 0 : 5;
    this.bigbreakpoint = (event.target.innerWidth <= 900) ? 15 : 5;
  }

  sortByName(a, b) {
    if (a.name < b.name)
      return -1;
    if (a.name > b.name)
      return 1;
    return 0;
  }

  ngOnInit() {
    window.scroll(0, 0);
    this.noticiaActual = this.news[0];
    this.breakpoint = (window.innerWidth <= 900) ? 0 : 5;
    this.bigbreakpoint = (window.innerWidth <= 900) ? 15 : 5;
    this.analytics.logEvents("noticias: "+this.noticiaActual.id);
  }
  ngAfterContentInit() {
    this.subcribe.unsubscribe();
  }


  convertToLocalDate(date) {
    var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

    var offset = date.getTimezoneOffset() / 60;
    var hours = date.getHours();

    newDate.setHours(hours - offset);

    return newDate;
  }

  cambiar(id) {
    this.news.forEach(element => {
      if (element.id == id) {
        this.noticiaActual = element;
      }
    });
    let element = document.getElementById('tpid');
    element.scrollIntoView({ behavior: 'smooth' });
  }
  scroll(el: HTMLElement, num: number) {
    el.scrollIntoView();
    this.noticiaActual = this.news[num];
  }

  movesCategory() {
    let element = document.getElementById('moveCategory');
    element.scrollIntoView({ behavior: 'smooth' });
  }

  fragmentarDataSource() {
    var i;
    this.datosAbajo = [];
    this.datosArriba = [];
    for (i = 0; i < this.datasourcenew.length; i++) {
      if (i % 2 == 0) {
        this.datosArriba.push(this.datasourcenew[i]);
      }
      else {
        this.datosAbajo.push(this.datasourcenew[i]);
      }
    }
  }

  cambiarCategoria(nombre) {
    this.quantityNews = 0;
    var bandera = true;
    this.news.forEach(element => {

      if (element.category.name == nombre) {
        if (bandera) {
          this.noticiaActual = element;
          bandera = false;
        }
        return false;
      }
    });
    ELEMENT_DATA_NEW = [];
    this.llenarDataSourceNew();
    this.datasourcenew = ELEMENT_DATA_NEW;
    this.fragmentarDataSource();
    let element = document.getElementById('tpid');
    element.scrollIntoView({ behavior: 'smooth' });
  }

  llenarDataSourceNew() {
    ELEMENT_DATA_NEW = [];
    let noticiaActualFilter = this.news.filter(data => data.category.id == this.noticiaActual.category.id);
    this.quantityNews = this.quantityNews + 10;
    if(this.quantityNews > noticiaActualFilter.length){
      this.quantityNews = noticiaActualFilter.length;
      this.disabledScroll = true;
    }
    for (let index = 0; index < this.quantityNews; index++) {
      if(this.quantityNews <= noticiaActualFilter.length){
        this.datasugerecias = {
          id: noticiaActualFilter[index].id,
          categoria: noticiaActualFilter[index].category.name,
          year: noticiaActualFilter[index].dateOfNew,
          image: noticiaActualFilter[index].image,
          title: noticiaActualFilter[index].title,
          autor: noticiaActualFilter[index].autor
        }
      }
      ELEMENT_DATA_NEW.push(this.datasugerecias);
    }

    this.datasourcenew = ELEMENT_DATA_NEW;
    this.fragmentarDataSource();
  }

  llenarDataSourceCategorias() {
    this.categorys.forEach(element => {
      this.datasugereciascate = {
        nombre: element.name,
        image: element.image
      }
      ELEMENT_DATA_NEW_CATEGORIAS.push(this.datasugereciascate);
    });
  }
}
